import {VuexModule, Module, Mutation, Action, MutationAction} from 'vuex-module-decorators';
import _ from 'lodash';
import { clientApi } from '@/http/ClientApi';
import { store } from "@returns-centre/store";

@Module({ name: 'returnCarrierServiceModule', namespaced: true })
export default class ReturnCarrierServiceModule extends VuexModule {

    errors: ValidationErrors = {};
    return_carrier_services: ReturnCarrierService[] = [];
    is_fetching_return_carrier_services: boolean = false;

    get isFetchingReturnCarrierServices(): boolean {
        return this.is_fetching_return_carrier_services;
    }

    get getShippingReturnFees() {
        return (returnCarrierService: ReturnCarrierService): string => {
            if(returnCarrierService.rate  <= 0) {
                return (0).toFixed(2);
            }
            let percentage: number =
                store.state.shopModule.shop.shipping_fee_customer_share_percentage;
            return ((_.toNumber(returnCarrierService.rate) * percentage) / 100).toFixed(2);
        };
    }

    @Action
    async fetchReturnCarrierServices(tradeInId: number): Promise<void> {
        this.context.commit('SET_ERRORS', {});
        this.context.commit('SET_TRADE_IN_STEP_DISABLED', false);
        this.context.commit('SET_IS_FETCHING_RETURN_CARRIER_SERVICES', true);
        await clientApi.getReturnCarrierServices(tradeInId)
            .then((res) => {
                this.context.commit('SET_RETURN_CARRIER_SERVICES', res);
            }).catch((e) => {
                this.context.commit('SET_ERRORS', e.response.data.errors);
                this.context.commit('SET_TRADE_IN_STEP_DISABLED', true);
            }).finally(() => {
                this.context.commit('SET_IS_FETCHING_RETURN_CARRIER_SERVICES', false);
            });

    }

    @Mutation
    SET_RETURN_CARRIER_SERVICES(returnCarrierServices: ReturnCarrierService[]): void {
        this.return_carrier_services = returnCarrierServices;
    }

    @Mutation
    SET_IS_FETCHING_RETURN_CARRIER_SERVICES(val: boolean) {
        this.is_fetching_return_carrier_services = val;
        store.state.tradeInModule.is_action_processing =  val;
    }

    @Mutation
    SET_ERRORS(errors: ValidationErrors) {
        this.errors = errors;
    }

    @Mutation
    SET_TRADE_IN_STEP_DISABLED(val: boolean) {
        store.state.tradeInModule.trade_in_step_disabled = val;
    }

}
